/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid, Typography, IconButton, Box, Checkbox, Menu, MenuItem, ListItemIcon, ListItemText, Button, Tooltip } from '@mui/material';
import { CancelPresentationRounded, ContentCopyOutlined, DeleteRounded, DirectionsRunRounded, SaveRounded, RotateLeftRounded, FileDownload, CandlestickChartOutlined, PreviewRounded, PrintRounded, SwapVertOutlined, NoteAltRounded, ReadMoreOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';
import columns from './table_config';
import styles, { listItemTextPrimary } from './styles';
import ModalDialog from '../ModalDialog';
import Datagrid from '../Datagrid';
import ReactJson from 'react-json-view';
import { addNewHydraulicsRow, copyRun, createHydraulics, deleteHydraulics, downloadRunInputs, downloadWellsRunsPDF, fetchHydraulicsDrillstringDrillFluid, listHydraulics, listHydraulicsDetails, listMudPumps, updateHydraulics, updateHydraulicsRunPosition } from '../../../store/actions/hydraulics';
import HydraulicsDetailsModal from './HydraulicsRunModalDialog';
import { enqueueSnackbar } from '../../../store/actions/snackbar';
import { REDUX_ACTIONS } from '../../../shared/config/constants';
import SelectEditInputTextField from '../SelectEditInputTextField';
import DepthVsDensityChartDialog from './DepthVsDensityChartDialog';
import DeleteConfirmationModal from '../../deleteConfirmationModal';
import useUnsavedChanges from '../../../hooks/useUnsavedChanges';
import useUnitConversion from '../../../hooks/useUnitConversion';
import ConfirmationModal from '../../confirmationModal';
import StrippingChart from './StrippingChartDialog';
import ParametricAnalysisChart from './ParametricAnalysisChartDialog';
import { COLORS } from '../../../shared/config/colors';
import NotesModal from './NotesDialog';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import RolloverChart from './RolloverChartDialog';
import HydraulicsRunCopyModal from './HydraulicsRunCopyModal';
import { listRollover } from '../../../store/actions/hydraulicsRollover';
import { UNIT_SYSTEM } from '../../../shared/config/hydraulics_constants';
import DisplacementChart from './DisplacementChartDialog';
import { APP_ACTION_TYPES, HYDRAULICS_ADMIN_ROLES, REPORT_INPUT_LIST, TOOLTIPS } from '../../../utils/constants';
import ReportInputsModal from './ReportInputsModal';
import { checkPermissions } from '../../../utils/checkPermissions';

const HydraulicsModal = ({
  onCloseClick,
  selectedJob,
  isOpen,
  wellDetails
}) => {
  const dispatch = useDispatch();
  const classes = styles();
  const apiRef = useGridApiRef();
  const hydraulics = useSelector((state) => state.hydraulics);
  const user = useSelector((state) => state.currentUser);
  const [properties, setProperties] = useState([]);
  const [invalidRows, setInvalidRows] = useState({});
  const [showHydraulicsParameterDialog, setShowHydraulicsParameterDialog] = useState({
    open: false,
    data: {},
    dialogParameter: ''
  });
  const [showDepthVsDensity, setShowDepthVsDensity] = useState({
    open: false,
    runId: null,
  });
  const [deleteAction, setDeleteAction] = useState(false);
  const [deleteRow, setDeleteRow] = useState();
  const { unit } = useUnitConversion();
  const [showRolloverChartModal, setShowRolloverChartModal] = useState({
    open: false,
    runId: null
  });
  const [showDisplacementChartModal, setShowDisplacementChartModal] = useState({
    open: false,
    runId: null
  });
  const {
    unSavedExists,
    handleClose,
    UnsavedChangesModal
  } = useUnsavedChanges(properties, onCloseClick);
  const [showStrippingChartModal, setShowStrippingChartModal] = useState({
    open: false,
    runId: null
  });
  const [showParametricAnalysisChartModal, setShowParametricAnalysisChartModal] = useState({
    open: false,
    runId: null
  });
  const [loader, setLoader] = useState(false);
  const [selectedRunIds, setSelectedRunIds] = useState([]);
  const [runCopySimulation, setRunCopySimulation] = useState(false);
  const [showCopyAgainConfirmationModal, setShowCopyAgainConfirmationModal] = useState({
    open: false,
    data: null,
  });
  const [showNotesModal, setShowNotesModal] = useState({
    open: false,
    data: null
  });
  const [notes, setNotes] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseDropDown = () => setAnchorEl(null);
  const [showCopyRunModal, setShowCopyRunModal] = useState({
    open: false,
    data: null,
  });
  const [showReportInput, setShowReportInputs] = useState(false);
  const [tableList, setTableList] = useState(REPORT_INPUT_LIST.map(item => item.key));
  const [reportPreview, setReportPreview] = useState(false);
  const disableAction = properties.some(item => item?.isDirty === true || item?.isNewRow);

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchHydraulicsDrillstringDrillFluid(selectedJob?.wellsInfoId));
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && (selectedJob?._id || selectedJob?.wellsInfoId)) {
      const query = selectedJob?.fromWells
        ? {
            wellsInfoId: selectedJob?.wellsInfoId
          }
        : {
            jobId: selectedJob?._id
          };
      dispatch(listHydraulics(query, onCloseClick));
    }

    return () => {
      dispatch({
        type: REDUX_ACTIONS.WELLS_WINDOW_RESET
      });
    };
  }, [isOpen]);

  useEffect(() => {
    if (!hydraulics.loading && !hydraulics?.drillDetails?.loading) {
      setProperties(hydraulics?.data);
    }
  }, [hydraulics]);

  useEffect(() => {
    if (loader || runCopySimulation) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = 'default';
    }
    return () => {
      document.body.style.cursor = 'default';
    };
  }, [loader, runCopySimulation]);

  useEffect(() => {
    if (properties[0]?.name === '') {
      const id = properties[0]._id;
      setTimeout(() => {
        apiRef.current.scrollToIndexes({
          rowIndex: 0
        });
        apiRef.current.setCellMode(id, 'name', 'edit');
        setTimeout(() => {
          apiRef.current.setCellFocus(id, 'name');
        }, 50);
      }, 50);
      apiRef.current.setPage(0);
    }
  }, [properties?.length]);

  const closeHandler = () => {
    if (unSavedExists) {
      handleClose(false);
      return;
    }
    setProperties([]);
    onCloseClick();
  };

  const handlePDFDownload = () => {
    const body = {
      inputs: tableList,
      jobId: selectedJob._id,
      wellsInfoId: selectedJob.wellsInfoId,
      runId: selectedRunIds,
      wellName: selectedJob?.Well,
      rigName: selectedJob?.Rig,
    };
    setLoader(true);
    dispatch(downloadWellsRunsPDF(body, reportPreview, () => {
      setLoader(false);
    }, selectedJob?.fromWells));
  };

  const areAllRunsReadyForReport = selectedRunIds.length > 0 && selectedRunIds.every(id => {
    const run = properties.find(r => r._id === id);
    if (!run) return false;

    switch (run.type) {
      case 'parametricAnalysis':
        return run.isParametricResults === true;
      case 'stripping':
        return run.isStrippingResults === true;
      case 'rollover':
        return run.isRolloverResults === true;
      case 'displacement':
        return run.isDisplacementResults === true;
      case 'hydraulicsRun':
        return run.results?.depth_points?.length !== 0;
      default:
        return false;
    }
  });

  const getModalTitle = () => {
    return (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          {`${selectedJob?.Rig || ''} | ${selectedJob?.Well || ''}`}
        </Grid>
        <Grid item>
          <Tooltip title={TOOLTIPS.printReport}>
            <span>
              <IconButton
                disabled={hydraulics.downloadWellsRunPdf === 'loading' || !selectedRunIds.length || !areAllRunsReadyForReport}
                onClick={() => {
                  setShowReportInputs(true);
                  setReportPreview(false);
                }}>
                <PrintRounded fontSize='large' />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={TOOLTIPS.viewReport}>
          <span>
          <IconButton
            disabled={hydraulics.downloadWellsRunPdf === 'loading' || !selectedRunIds.length || !areAllRunsReadyForReport}
            onClick={() => {
              setShowReportInputs(true);
              setReportPreview(true);
            }}>
            <PreviewRounded fontSize='large' />
          </IconButton>
          </span>
          </Tooltip>
          <IconButton
            onClick={closeHandler}
          >
            <CancelPresentationRounded fontSize='large' />
          </IconButton>
        </Grid>
      </Grid>
    );
  };

  const addHydraulics = (type) => {
    dispatch(addNewHydraulicsRow(type));
  };

  const handleSave = (row) => {
    apiRef.current.setCellMode(row._id, 'name', 'view');
    if (row?.name) {
      setInvalidRows(prev => ({ ...prev, [row._id]: false }));
      if (row?.isNewRow) {
        delete row?.isNewRow;
        dispatch(createHydraulics(row, selectedJob?._id, selectedJob.wellsInfoId, false, selectedJob?.fromWells));
      } else {
        dispatch(updateHydraulics({ ...row }, selectedJob?.fromWells));
      }
      setTimeout(() => {
        Object.keys(row).forEach((field) => {
          if (field !== '_id' && field !== 'name') {
            apiRef.current.setCellMode(row._id, field, 'view');
          }
        });
      }, 100);
    } else {
      setInvalidRows(prev => ({ ...prev, [row._id]: true }));
      dispatch(
        enqueueSnackbar(
          'Please enter the name',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      return false;
    }
  };

  const removeHydraulics = (row) => {
    apiRef.current.setCellMode(row?._id, 'name', 'view');
    if (row?.isNewRow) {
      const updatedHydraulics = properties.filter(item => item._id !== row?._id);
      setProperties(updatedHydraulics);
      const query = selectedJob?.fromWells
        ? {
            wellsInfoId: selectedJob?.wellsInfoId
          }
        : {
            jobId: selectedJob?._id
          };
      dispatch(listHydraulics(query));
    } else {
      const query = selectedJob?.fromWells
        ? {
            wellsInfoId: selectedJob?.wellsInfoId
          }
        : {
            jobId: selectedJob?._id
          };
      dispatch(deleteHydraulics(row?._id, query));
    }
    setDeleteAction(false);
    setDeleteRow({});
  };

  const copyHydraulicsRun = (rowData, selectedType) => {
    const body = {
      query: selectedJob?.fromWells
        ? {
            wellsInfoId: selectedJob?.wellsInfoId
          }
        : {
            jobId: selectedJob?._id
          },
      runId: rowData?._id,
      submitRunType: selectedType
    };
    setRunCopySimulation(true);
    dispatch(copyRun(body, () => {
      setShowCopyRunModal(
        {
          open: false,
          data: {}
        }
      );
      setRunCopySimulation(false);
    }, () => {
      setShowCopyAgainConfirmationModal({
        open: true,
        data: null
      });
    }));
  };

  const RenderJsonField = ({ value }) => {
    const data = useRef(value.run_details);
    return <React.Fragment>
      <ReactJson
        src={data.current}
        name={false}
        sortKeys={true}
        collapsed={true}
        displayDataTypes={false}
        quotesOnKeys={false}
      />
    </React.Fragment>;
  };

  const renderResultCell = (row) => {
    const hasDepthPoints = row?.row?.results?.summary?.bh_ecd;
    const hasPressure = row?.row?.results?.summary;
    const targetData = row?.row?.run_details_copy?.target_data;
    const decimals = hydraulics?.units?.inputs?.target_data?.target_ecd?.decimals ?? 2;
    const convertedECD = parseFloat(targetData?.target_ecd);
    const targetECD = Number(convertedECD) ? convertedECD.toFixed(decimals) : '';
    const anchorPoint = targetData?.anchor_point;
    const isTargetDataEmpty = !targetData || Object.keys(targetData).length === 0 || targetData?.anchor_point === 'None';
    const rowPermissions = row?.row?.permissions;

    const getFormattedPressure = () => {
      const target_sbp = row?.row?.results?.summary?.target_sbp;
      const connection_sbp = row?.row?.results?.summary?.connection_sbp;
      const decimals_target = hydraulics?.units?.results?.summary?.target_sbp?.decimals ?? 1;
      const decimals_connection = hydraulics?.units?.results?.summary?.connection_sbp?.decimals ?? 1;
      if (target_sbp == null && connection_sbp == null) return '-';
      const formattedTarget = target_sbp == null ? '-' : unit !== UNIT_SYSTEM.US ? target_sbp : target_sbp.toFixed(decimals_target);
      const formattedConnection = connection_sbp == null ? '-' : unit !== UNIT_SYSTEM.US ? connection_sbp : connection_sbp.toFixed(decimals_connection);
      return `${formattedTarget}/${formattedConnection}`;
    };

    const getFormattedBHECD = () => {
      const summary = row?.row?.results?.summary ?? {};

      const bhEcdWithSbp = summary.bh_ecd_with_sbp;
      const bhEsdWithConnSbp = summary.bh_esd_with_connection_sbp;
      const ecdDecimals = hydraulics?.units?.results?.summary?.bh_ecd_with_sbp?.decimals;
      const esdDecimals = hydraulics?.units?.results?.summary?.bh_esd_with_connection_sbp?.decimals;

      const formatValue = (value, decimals) => {
        if (value == null || Number.isNaN(value)) return '-';
        return unit !== UNIT_SYSTEM.US
          ? value
          : Number(value).toFixed(decimals);
      };

      const formattedEcd = formatValue(bhEcdWithSbp, ecdDecimals);
      const formattedEsd = formatValue(bhEsdWithConnSbp, esdDecimals);

      return `${formattedEcd}/${formattedEsd}`;
    };

    const checkDisabledRow = () => {
      if (disableAction) {
        dispatch(
          enqueueSnackbar(
            'Please save changes before proceeding',
            'error',
            new Date().getTime() + Math.random()
          )
        );
        return true;
      }
      return false;
    };

    const iconMap = {
      stripping: {
        condition: row?.row?.isStrippingResults,
        content: (
          <IconButton onClick={() => {
            if (checkDisabledRow()) return;
            setShowStrippingChartModal({
              open: true,
              runId: row?.row?._id,
            });
          }}
          disabled={hydraulics?.loading}>
            <SwapVertOutlined htmlColor={COLORS.OLD_FONT_BLUE} />
          </IconButton>
        )
      },
      parametricAnalysis: {
        condition: row?.row?.isParametricResults,
        content: (
          <IconButton onClick={() => {
            if (checkDisabledRow()) return;
            setShowParametricAnalysisChartModal({
              open: true,
              runId: row?.row?._id,
            });
          }}
          disabled={hydraulics?.loading}>
            <CandlestickChartOutlined htmlColor={COLORS.OLD_FONT_BLUE} />
          </IconButton>
        )
      },
      displacement: {
        condition: row?.row?.isDisplacementResults,
        content: (
          <IconButton onClick={() => {
            if (checkDisabledRow()) return;
            setShowDisplacementChartModal({
              open: true,
              runId: row?.row?._id,
            });
          }}
          disabled={hydraulics?.loading}>
            <ReadMoreOutlined sx={{ transform: 'rotate(90deg)' }} htmlColor={COLORS.OLD_FONT_BLUE} />
          </IconButton>
        )
      },
      rollover: {
        condition: row?.row?.isRolloverResults,
        content: (
          <IconButton onClick={() => {
            if (checkDisabledRow()) return;
            setShowRolloverChartModal({
              open: true,
              runId: row?.row?._id,
            });
          }}
          disabled={hydraulics?.loading}>
            <RotateLeftRounded htmlColor={COLORS.OLD_FONT_BLUE} />
          </IconButton>
        )
      },
      hydraulicsRun: {
        content: (hasDepthPoints || hasPressure)
          ? (
            <Box disabled={row?.isNewRow || hydraulics?.loading} style={{ cursor: 'pointer', justifyItems: 'center' }} onClick={() => {
              if (checkDisabledRow()) return;
              if (row?.isNewRow || hydraulics?.loading) return;
              if (!checkPermissions(APP_ACTION_TYPES.VIEW, rowPermissions)) {
                dispatch(
                  enqueueSnackbar(
                    `You do not have permission to view results for ${row?.row?.name}`,
                    'error',
                    new Date().getTime() + Math.random()
                  )
                );
                return;
              }
              setShowDepthVsDensity({
                open: true,
                runId: row?.row?._id,
              });
            }}
            >
              <Box>
                {isTargetDataEmpty
                  ? (
                    <Typography variant="body2" fontWeight={600} color={COLORS.OLD_FONT_BLUE}>
                      {getFormattedBHECD()} {hydraulics?.units?.results?.summary?.bh_ecd_with_sbp?.label} Drilling/Conn. BH ECD
                    </Typography>
                    )
                  : (
                    <Typography variant="body2" fontWeight={600} color={COLORS.OLD_FONT_BLUE}>
                      {targetECD} {hydraulics.units.inputs.target_data.target_ecd.label} @ {anchorPoint}
                    </Typography>
                    )}
              </Box>
              <Box>
                {hasPressure && (
                  <Typography variant="body2" fontWeight={600} color={COLORS.OLD_FONT_BLUE}>
                    {getFormattedPressure()} {hydraulics?.units?.results?.summary?.connection_sbp?.label} Drilling/Conn. SBP
                  </Typography>
                )}
              </Box>
            </Box>
            )
          : null
      }
    };

    const config = iconMap[row?.row?.type];

    return (
      <Grid container justifyContent="center" alignItems="center">
        {row?.row?.type === 'hydraulicsRun'
          ? config?.content
          : config?.condition
            ? config?.content
            : null}
      </Grid>
    );
  };

  const renderNotesCell = ({ row }) => {
    return (
      <Grid container justifyContent="center">
        <IconButton
          disabled={(!row.isNewRow && !checkPermissions(APP_ACTION_TYPES.UPDATE, row?.permissions))}
          onClick={() => {
            setNotes(row?.notes || '');
            setShowNotesModal({
              open: true,
              data: row
            });
          }}>
          {row?.notes?.length ? <NoteAltRounded htmlColor={COLORS.OLD_FONT_BLUE} /> : <NoteAltRounded htmlColor={COLORS.GRAY} />}
        </IconButton>
      </Grid>
    );
  };

  const renderActionCell = ({ row, id }) => {
    const rowIndex = apiRef?.current?.getRowIndexRelativeToVisibleRows(id) + 1;
    return (
      <Grid container justifyContent="center">
        <Tooltip title={TOOLTIPS.save}>
          <span>
            <IconButton
              variant="solid"
              disabled={!row.isDirty || hydraulics?.loading || (!row.isNewRow && !checkPermissions(APP_ACTION_TYPES.UPDATE, row?.permissions))}
              onClick={() => handleSave({ ...row, index: row?.isNewRow ? properties.length : rowIndex })}
            >
              <SaveRounded />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={TOOLTIPS.copy}>
          <span>
            <IconButton
              variant="solid"
              disabled={disableAction || (!row.isNewRow && !checkPermissions(APP_ACTION_TYPES.CREATE, row?.permissions))}
              onClick={() => setShowCopyRunModal({ open: true, data: row })}
            >
              <ContentCopyOutlined />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={TOOLTIPS.delete}>
          <span>
            <IconButton
              variant="solid"
              disabled={hydraulics?.loading || (!row.isNewRow && !checkPermissions(APP_ACTION_TYPES.DELETE, row?.permissions))}
              onClick={() => {
                setDeleteAction(true);
                setDeleteRow(row);
              }}
            >
              <DeleteRounded />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={TOOLTIPS.downloadJson}>
          <span>
            <IconButton
              variant="solid"
              disabled={
                hydraulics?.loading ||
                disableAction ||
                hydraulics.downloadModel === 'loading' ||
                !HYDRAULICS_ADMIN_ROLES.includes(user.type)
              }
              onClick={() => {
                const payload = {
                  fileName: `${selectedJob?.Rig?.trim()}_${selectedJob?.Well?.trim()}_${row.name?.trim()}_inputs`,
                  runsId: row._id,
                  wellsInfoId: row.wellsInfoId
                };
                dispatch(downloadRunInputs(payload));
              }}
            >
              <FileDownload />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
    );
  };

  const updateData = (id, field, value) => {
    setProperties(prevProperties => {
      const updatedProperties = prevProperties.map(item => {
        if (item._id === id) {
          const isDirty = value !== item[field];
          return {
            ...item,
            [field]: value,
            isDirty
          };
        }
        return item;
      });
      return updatedProperties;
    });
  };
  const renderValueCell = (params) => {
    return <SelectEditInputTextField {...params} updateData={updateData} />;
  };

  const renderRunReportCell = (params) => {
    const runId = params?.row?._id;
    const isSelected = selectedRunIds.includes(runId);
    return (
      <Box className={classes.checkBoxCell}>
        <Checkbox
          size="small"
          checked={isSelected}
          disabled={properties[0]?.isNewRow}
          onClick={() => {
            setSelectedRunIds(prev =>
              isSelected ? prev.filter(id => id !== runId) : [...prev, runId]
            );
          }}
        />
      </Box>
    );
  };

  const handleCloseDialog = () => {
    setShowHydraulicsParameterDialog({
      open: false,
      data: {}
    });
    dispatch({
      type: REDUX_ACTIONS.HYDRAULICS_SET_ID,
      payload: {
        data: '',
      },
    });
  };

  const SubmitCell = ({ row }) => {
    const type = row?.type;

    const checkRunViewPermissions = () => {
      if (!checkPermissions(APP_ACTION_TYPES.VIEW, row?.permissions)) {
        dispatch(
          enqueueSnackbar(
            `You do not have permission to view inputs for ${row?.name}`,
            'error',
            new Date().getTime() + Math.random()
          )
        );
        return false;
      }
      return true;
    };

    const buttonMap = {
      hydraulicsRun: {
        label: 'Hydraulics Run',
        icon: <DirectionsRunRounded />,
        onClick: () => {
          if (!checkRunViewPermissions()) return;
          dispatch(listHydraulicsDetails(row?._id, handleCloseDialog));
          setShowHydraulicsParameterDialog({
            open: true,
            data: row,
            dialogParameter: ''
          });
        }
      },
      rollover: {
        label: 'Rollover',
        icon: <RotateLeftRounded />,
        onClick: () => {
          if (!checkRunViewPermissions()) return;
          dispatch(listMudPumps(row?.wellsInfoId));
          dispatch(listHydraulicsDetails(row?._id, handleCloseDialog));
          setShowHydraulicsParameterDialog({
            open: true,
            data: row,
            dialogParameter: 'rollover'
          });
          dispatch(listRollover({ runId: row?._id, wellsInfoId: row?.wellsInfoId }));
        }
      },
      stripping: {
        label: 'Stripping',
        icon: <SwapVertOutlined />,
        onClick: () => {
          if (!checkRunViewPermissions()) return;
          dispatch(listHydraulicsDetails(row?._id, handleCloseDialog));
          setShowHydraulicsParameterDialog({
            open: true,
            data: row,
            dialogParameter: 'stripping'
          });
        }
      },
      parametricAnalysis: {
        label: 'Parametric Analysis',
        icon: <CandlestickChartOutlined />,
        onClick: () => {
          if (!checkRunViewPermissions()) return;
          dispatch(listHydraulicsDetails(row?._id, handleCloseDialog));
          setShowHydraulicsParameterDialog({
            open: true,
            data: row,
            dialogParameter: 'parametricAnalysis'
          });
        }
      },
      displacement: {
        label: 'Displacement',
        icon: <ReadMoreOutlined sx={{ transform: 'rotate(90deg)' }} />,
        onClick: () => {
          if (!checkRunViewPermissions()) return;
          dispatch(listHydraulicsDetails(row?._id, handleCloseDialog));
          setShowHydraulicsParameterDialog({
            open: true,
            data: row,
            dialogParameter: 'displacement'
          });
        }
      }
    };

    const config = buttonMap[type];
    if (!config) return null;

    return (
      <Box>
        <Button
          size="small"
          startIcon={config.icon}
          onClick={() => {
            if (disableAction) {
              dispatch(
                enqueueSnackbar(
                  'Please save changes before proceeding',
                  'error',
                  new Date().getTime() + Math.random()
                )
              );
              return;
            }
            config.onClick();
          }}
          disabled={row?.isNewRow || hydraulics?.loading}
        >
          {config.label}
        </Button>
      </Box>
    );
  };

  const renderSubmitCell = () => {
    const NamedSubmitCell = (params) => <SubmitCell {...params} />;
    NamedSubmitCell.displayName = 'NamedSubmitCell';
    return NamedSubmitCell;
  };

  if (apiRef.current === null) apiRef.current = {};

  const handleRowOrderChange = async (params) => {
    if (params?.oldIndex !== params?.targetIndex) {
      const body = {
        index: params?.targetIndex + 1,
        wellsInfoId: params?.row?.wellsInfoId,
        jobId: !selectedJob?.fromWells && selectedJob?._id,
        runId: params?.row?._id
      };
      const listQuery = selectedJob?.fromWells
        ? {
            wellsInfoId: selectedJob?.wellsInfoId
          }
        : {
            jobId: selectedJob?._id
          };
      dispatch(updateHydraulicsRunPosition(body, listQuery));
      Object.keys(params?.row).forEach((field) => {
        apiRef.current.setCellMode(params?.row._id, field, 'view');
      });
    }
  };

  return (
    <React.Fragment>
      <ModalDialog
        title={getModalTitle()}
        isOpen={isOpen}
        onClose={() => {
          closeHandler();
        }}
        dialogClass={classes.dialogModal}
        maxWidth={'lg'}
      >
        <Grid container>
          <Grid item sx={{ display: !checkPermissions(APP_ACTION_TYPES.CREATE, hydraulics?.permissions) && 'none !important' }} className={hydraulics.loading || disableAction ? classes.disableIcon : classes.customTool} onClick={(e) => {
            handleClick(e);
          }} xs={1}>
            <Grid item>
              <IconButton
                disabled={hydraulics.loading || properties[0]?.isNewRow}>
                <ArrowDropDownIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography variant='button' fontWeight='700'>+ Add</Typography>
            </Grid>
          </Grid>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseDropDown}
            sx={{ display: !checkPermissions(APP_ACTION_TYPES.CREATE, hydraulics?.permissions) && 'none !important' }}
          >
            <MenuItem
              onClick={() => {
                handleCloseDropDown();
                addHydraulics('hydraulicsRun');
              }}
            >
              <ListItemIcon>
                <DirectionsRunRounded fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary="Hydraulics Run"
                primaryTypographyProps={listItemTextPrimary}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseDropDown();
                addHydraulics('stripping');
              }}
            >
              <ListItemIcon>
                <SwapVertOutlined fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary="Stripping"
                primaryTypographyProps={listItemTextPrimary}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseDropDown();
                addHydraulics('rollover');
              }}
            >
              <ListItemIcon>
                <RotateLeftRounded fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary="Rollover"
                primaryTypographyProps={listItemTextPrimary}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseDropDown();
                addHydraulics('displacement');
              }}
            >
              <ListItemIcon>
                <ReadMoreOutlined fontSize="medium" sx={{ transform: 'rotate(90deg)' }} />
              </ListItemIcon>
              <ListItemText primary="Displacement"
                primaryTypographyProps={listItemTextPrimary}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseDropDown();
                addHydraulics('parametricAnalysis');
              }}
            >
              <ListItemIcon>
                <CandlestickChartOutlined fontSize="medium" />
              </ListItemIcon>
              <ListItemText
                primary="Parametric Analysis"
                primaryTypographyProps={listItemTextPrimary}
              />
            </MenuItem>
          </Menu>
          <Grid item xs={12}>
            <Datagrid
              apiRef={apiRef}
              data={properties}
              sx={{
                marginLeft: '-6px',
                '.MuiDataGrid-cell': {
                  fontSize: '1rem',
                  fontWeight: 900,
                  textAlign: 'justify'
                },
                '.MuiDataGrid-columnHeader': {
                  fontSize: '1.2rem',
                  fontWeight: '900 !important'
                },
                '& .cellLink': {
                  color: COLORS.OLD_FONT_BLUE,
                  cursor: 'pointer'
                },
                '.MuiDataGrid-rowReorderCell': {
                  opacity: disableAction || selectedRunIds?.length ? 0.38 : '',
                  pointerEvents: disableAction || selectedRunIds?.length ? 'none' : '',
                },
              }}
              loading={hydraulics.loading || hydraulics?.drillDetails?.loading || hydraulics?.drillFluidProperty?.loading}
              columns={columns(RenderJsonField, renderActionCell, renderValueCell, renderRunReportCell, renderNotesCell, renderSubmitCell(), renderResultCell)}
              onRowClick={(params, evt) => {
                evt.preventDefault();
                evt.stopPropagation();
              }}
              disableStickyHeader={false}
              autoHeight={false}
              getRowId={(row) => row._id}
              getRowHeight={() => 'auto'}
              height={'50vh'}
              getRowClassName={(params) => {
                const isSelected = selectedRunIds.includes(params.id);
                const isInvalid = invalidRows[params.id];
                const isEditable = params?.row?.permissions?.update;

                return `${isInvalid ? classes.invalidRow : ''} ${!isSelected ? classes.hideReorder : ''} ${!isEditable && !params?.row?.isNewRow ? classes.rowViewMode : ''}`;
              }}
              rowReordering={hydraulics?.permissions?.update && properties.length > 1 && properties.every(item => 'index' in item)}
              onRowOrderChange={handleRowOrderChange}
              pageSize={100}
              editMode="cell"
              toolbar={{
                options: {
                  columns: true,
                  filters: false,
                  density: false,
                  export: false
                },
              }}
              enableDirtyLock
            />
          </Grid>
        </Grid>
      </ModalDialog>
      {
        deleteAction && <DeleteConfirmationModal
          open={deleteAction}
          handleDelete={removeHydraulics}
          handleClose={setDeleteAction}
          deleteRow={deleteRow}
        />
      }
      <UnsavedChangesModal />
      {showHydraulicsParameterDialog.open && showHydraulicsParameterDialog?.data?.name
        ? (
          <HydraulicsDetailsModal
            selectedJob={selectedJob}
            isOpen={showHydraulicsParameterDialog.open}
            onCloseClick={() => {
              handleCloseDialog();
            }}
            data={showHydraulicsParameterDialog.data}
            dialogParameter={showHydraulicsParameterDialog.dialogParameter}
            wellDetails={wellDetails}
          />
          )
        : null}
      {showDepthVsDensity.open && (
        <DepthVsDensityChartDialog
          isOpen={showDepthVsDensity.open}
          onCloseClick={() => {
            setShowDepthVsDensity({
              open: false,
              runId: null,
            });
          }}
          wellDetails={selectedJob}
          data={properties.find(p => p._id === showDepthVsDensity?.runId)}
          rowData={properties.find(p => p._id === showDepthVsDensity?.runId)}
          hydraulicWellsDetails={wellDetails}
        />
      )}
      {
        showRolloverChartModal.open
          ? <RolloverChart
            wellDetails={selectedJob}
            hydraulicWellsDetails={wellDetails}
            rowData={properties.find(p => p._id === showRolloverChartModal?.runId)}
            isOpen={showRolloverChartModal.open}
            onCloseClick={() => {
              setShowRolloverChartModal({
                open: false,
                runId: null
              });
            }}
          />
          : null
      }
      {
        showDisplacementChartModal.open
          ? <DisplacementChart
            wellDetails={selectedJob}
            hydraulicWellsDetails={wellDetails}
            rowData={properties.find(p => p._id === showDisplacementChartModal?.runId)}
            isOpen={showDisplacementChartModal.open}
            onCloseClick={() => {
              setShowDisplacementChartModal({
                open: false,
                runId: null
              });
            }}
          />
          : null
      }
      {
        showParametricAnalysisChartModal.open
          ? <ParametricAnalysisChart
            wellDetails={selectedJob}
            hydraulicWellsDetails={wellDetails}
            rowData={properties.find(p => p._id === showParametricAnalysisChartModal?.runId)}
            isOpen={showParametricAnalysisChartModal.open}
            onCloseClick={() => {
              setShowParametricAnalysisChartModal({
                open: false,
                runId: null
              });
            }}
          />
          : null
      }
      {
        showStrippingChartModal.open
          ? <StrippingChart
            wellDetails={selectedJob}
            hydraulicWellsDetails={wellDetails}
            rowData={properties.find(p => p._id === showStrippingChartModal?.runId)}
            isOpen={showStrippingChartModal.open}
            onCloseClick={() => {
              setShowStrippingChartModal({
                open: false,
                runId: null
              });
            }}
          />
          : null
      }
      {
        showCopyRunModal.open
          ? <HydraulicsRunCopyModal
            confirmAction={runCopySimulation}
            rowData={showCopyRunModal.data}
            isOpen={showCopyRunModal.open}
            handleAction={(rowData, selectedType) => {
              copyHydraulicsRun(rowData, selectedType);
            }}
            onCloseClick={() => {
              setShowCopyRunModal(
                {
                  open: false,
                  data: {}
                }
              );
            }}
          />
          : null
      }
      {
        showCopyAgainConfirmationModal.open && <ConfirmationModal
          confirmAction={false}
          open={showCopyAgainConfirmationModal.open}
          rowData={showCopyAgainConfirmationModal.data}
          handleAction={() => {
            setShowCopyAgainConfirmationModal({
              open: false,
              data: null
            });
          }}
          handleClose={() => {
            setShowCopyAgainConfirmationModal({
              open: false,
              data: null
            });
          }}
          modalLabel={'Please rename the existing copy of the run before copying again'}
        />
      }
      {
        showReportInput
          ? <ReportInputsModal
            isOpen={showReportInput}
            tableList={tableList}
            setTableList={setTableList}
            onCloseClick={() => {
              setShowReportInputs(false);
            }}
            generateReport={handlePDFDownload}
          />
          : null
      }
      {
        showNotesModal.open
          ? <NotesModal
            rowData={showNotesModal.data}
            isOpen={showNotesModal.open}
            notes={notes}
            setNotes={setNotes}
            updateData={updateData}
            onCloseClick={() => {
              setShowNotesModal(
                {
                  open: false,
                  data: {}
                }
              );
            }}
          />
          : null
      }
    </React.Fragment>
  );
};
HydraulicsModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  selectedJob: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  wellDetails: PropTypes.any
};
HydraulicsModal.defaultProps = {
  selectedJob: {}
};
export default HydraulicsModal;
